
<template>
  <div>
    <b-button
      v-permission="'users.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew"
    >
      <feather-icon
        icon="PlusIcon"
        class="mr-50"
      />
      <span class="align-middle">{{$t('AddNew')}}</span>
    </b-button>

    <Grid
      :service="service"
      route_name="users"
      :column_formats="columnFormats"
    ></Grid>
  </div>
</template>


<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

import UserService from '@/services/api/UserService'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
  },
  data: () => ({
    selected: [],
    service: null,
    /*
     * Coluna "Cadastro como": o que a pessoa declarou querer ser ao criar a conta
     * (`users.signup_intent`), e é aqui que o lead de "quero ser professor"
     * aparece para quem cuida do relacionamento.
     *
     * O banco guarda o valor canônico em inglês, igual ao `person_type` que a
     * tela de cadastro envia — traduzir na exibição mantém o dado estável e o
     * grid em pt-BR. Vazio é quem nunca foi perguntado: o cadastro do
     * marketplace não tem esse campo, e nem toda conta é anterior a ele.
     */
    columnFormats: {
      signup_intent: value => ({
        student: 'Aluno',
        teacher: 'Professor'
      }[value] || '—')
    }
  }),
  methods: {
    addNew() {
      this.$router.push('/users/create')
    }
  },
  beforeMount() {
    this.service = UserService.build(this.$vs)
  }
}
</script>